import React, { useState } from 'react';
import { Search, ChevronDown, ChevronUp, RotateCcw, UserPlus } from 'react-feather';
import { Formik, Form } from 'formik';
import { useNavigate } from 'react-router-dom';
import FormikInput from '../../components/ui/FormikInput';
import TablaProfesores from '../../components/profesores/TablaProfesores';
import profesoresApiService from '../../services/http/profesoresApiService';
import logger from '../../services/logger';
import colors from '../../theme/colors';

const ListadoProfesores = () => {
  const [profesores, setProfesores] = useState([]);
  const [showFilters, setShowFilters] = useState(true);
  const navigate = useNavigate();

  const initialValues = {
    codigo: '', nombre: '', apellidos: '', movil: '', email: '', centro: 'CEDETECGROUP',
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await profesoresApiService.obtenerProfesores(values);
      setProfesores(response);
    } catch (error) {
      logger.error('Error al obtener profesores:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: '16px' }}>
        <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>Profesores</h1>
        <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
          Gestiona y busca profesores del sistema
        </p>
      </div>

      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ resetForm, isSubmitting }) => (
          <Form>
            <div style={{
              backgroundColor: '#fff', borderRadius: '12px',
              border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
              overflow: 'visible',
            }}>
              {/* Toolbar */}
              <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '12px 16px',
                borderBottom: showFilters ? '1px solid #f3f4f6' : 'none',
              }}>
                <button type="button" onClick={() => setShowFilters(!showFilters)} style={{
                  display: 'flex', alignItems: 'center', gap: '6px', background: 'none',
                  border: 'none', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600,
                  color: '#374151', padding: '4px 8px', borderRadius: '6px',
                }}>
                  <Search size={15} style={{ color: '#9ca3af' }} />
                  Filtros
                  {showFilters ? <ChevronUp size={14} style={{ color: '#9ca3af' }} /> : <ChevronDown size={14} style={{ color: '#9ca3af' }} />}
                </button>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button type="button" onClick={() => { resetForm(); setProfesores([]); }} style={{
                    display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px',
                    fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
                    border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#6b7280', cursor: 'pointer',
                  }} title="Limpiar filtros">
                    <RotateCcw size={13} />
                    Limpiar
                  </button>
                  <button type="submit" disabled={isSubmitting} style={{
                    display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 14px',
                    fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px', border: 'none',
                    backgroundColor: colors.primary, color: '#fff',
                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                    opacity: isSubmitting ? 0.5 : 1,
                  }} title="Buscar profesores">
                    <Search size={13} />
                    Buscar
                  </button>
                  <button type="button" onClick={() => navigate('/profesores/nuevo')} style={{
                    display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 14px',
                    fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
                    border: `1px solid ${colors.primary}`, backgroundColor: '#fff',
                    color: colors.primary, cursor: 'pointer',
                  }} title="Crear nuevo profesor">
                    <UserPlus size={13} />
                    Nuevo
                  </button>
                </div>
              </div>

              {/* Filtros colapsables */}
              {showFilters && (
                <div style={{
                  padding: '16px',
                  opacity: isSubmitting ? 0.5 : 1,
                  pointerEvents: isSubmitting ? 'none' : 'auto',
                  transition: 'opacity 0.2s',
                }}>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '12px' }}>
                    <FormikInput label="Código" name="codigo" type="number" placeholder="ID numérico" disabled={isSubmitting} />
                    <FormikInput label="Nombre" name="nombre" placeholder="Nombre" disabled={isSubmitting} />
                    <FormikInput label="Apellidos" name="apellidos" placeholder="Apellidos" disabled={isSubmitting} />
                    <FormikInput label="Móvil" name="movil" placeholder="Teléfono" disabled={isSubmitting} />
                    <FormikInput label="Email" name="email" type="email" placeholder="Email" disabled={isSubmitting} />
                    <FormikInput label="Centro" name="centro" type="select" options={['CEDETECGROUP', 'CEDESCA', 'CNTEC']} disabled={isSubmitting} />
                  </div>
                </div>
              )}
            </div>
          </Form>
        )}
      </Formik>

      {profesores.length > 0 && (
        <div style={{ marginTop: '16px' }}>
          <TablaProfesores data={profesores} />
        </div>
      )}
    </div>
  );
};

export default ListadoProfesores;
